import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from '@material-ui/core';

import {
  SelectValidator,
  ValidatorForm,
} from 'react-material-ui-form-validator';
import Buscador from '../../../../../actions/ui/Buscador';
import { useForm } from '../../../../../hooks/useForm';
import { NuevoProblemaAfiliado } from '../../../../../actions/hce/hceActions';

export const IngresoProblema = (props) => {
  const formInicial = {
    idEstadoProblema: 0,
  };
  const dispatch = useDispatch();
  const { estadosProblemas, hce } = props;
  const [value, setValue] = useState(null);
  const [formValues, handleInputChange] = useForm(formInicial);

  const onSubmitHandler = () => {
    if (value !== null && formValues.idEstadoProblema > 0) {
      const datos = {
        idAfiliado: hce.idAfiliado,
        idAfiliadoExterno: hce.idAfiliadoExterno,
        idProblema: value.idProblema,
        problema: value.problema,
        idEfectorRed: hce.idEfector,
        idAgenda: hce.idAgenda,
        idEstadoProblema: formValues.idEstadoProblema,
      };
      dispatch(NuevoProblemaAfiliado(datos));
      props.close();
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingLeft: 16 }}
            >
              <Buscador
                value={value}
                variant="outlined"
                setValue={(val) => setValue(val)}
                label="NOMBRE PROBLEMA"
                noOptionText={'No se encuentra problema'}
                endpoint={(nombreProblema) =>
                  `HCE/Buscador/traerProblemaPorNombre/${nombreProblema}`
                }
                getOptionLabel={(option) => `${option.problema} `}
                renderOption={(option) => (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ color: 'green' }}>
                      {`${option.problema}`}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                      }}
                    ></span>
                  </div>
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} style={{ paddingLeft: 16 }}>
              <SelectValidator
                margin="normal"
                label="Estado"
                name="idEstadoProblema"
                autoComplete="off"
                onChange={handleInputChange}
                value={formValues.idEstadoProblema}
                style={{ paddingRight: '0.5rem' }}
                fullWidth
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  "El estado es requerido, 'Debe seleccionar un estado'",
                ]}
              >
                <MenuItem value={0}>Seleccione estado</MenuItem>
                {estadosProblemas.map((pla) => (
                  <MenuItem key={pla.id} value={pla.id}>
                    {pla.estado}
                  </MenuItem>
                ))}
              </SelectValidator>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} style={{ paddingLeft: 16 }}>
              <div
                style={{
                  margin: '2rem 0',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={props.close}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={props.disabled}
                  color="primary"
                >
                  Guardar
                </Button>
              </div>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
